import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

import LoginVue from '@/views/Login'
import ReportsVue from '@/views/Reports'
import AnalyticsVue from '@/views/Analytics'
import ObjectsVue from '@/views/Objects'
import ModelingVue from '@/views/Modeling'
import IntegrationVue from '@/views/Integration'
import SettingsVue from '@/views/Settings'
//import TechnologiesVue from '@/views/Technologies'
import TerritoryVue from '@/views/Territory'
import ControlVue from '@/views/Control'
import ExcelLayersVue from '@/views/excel-layers/ExcelLayers'
import ExcelLayerVue from '@/views/excel-layers/ExcelLayer'
import ExcelLayerSettingsVue from '@/views/excel-layers/ExcelLayerSettings'
import ExcelObjectListVue from '@/views/excel-layers/ExcelObjectList'
import ExcelLayerListVue from '@/views/excel-layers/ExcelLayerList'
import ExcelLayerHistory from '@/views/excel-layers/ExcelLayerHistory'
import ExcelLayerCreateLog from '@/views/excel-layers/ExcelLayerCreateLog'
import store from '@/store/index'
import B3GisView from '@/components/B3Gis/B3GisView'
import { env } from '@/../config'

let mainStore = null

const requireAuth = (to, from, next) => {
  if (mainStore.getters.token) {
    next()
  } else {
    next('/login')
  }
}

const checkRoutePermissions = (next, permissionField) => {
  if (store.getters.token) {
    store.dispatch('loadUserData').then(() => {
      if (store.getters.permissions[permissionField]) {
        next()
      } else {
        next('/objects')
      }
    })
  } else {
    if (store.getters.isPublicWs) {
      next()
    } else {
      next('/login')
    }
  }
}

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginVue
  },
  {
    path: '/reports',
    name: 'reports',
    component: ReportsVue
  },
  {
    path: '/terschema',
    name: 'terschema',
    component: TerritoryVue,
    beforeEnter: (to, from, next) => {
      checkRoutePermissions(next, 'canReadTerschema')
    }
  },
  {
    path: '/analytics',
    name: 'analytics',
    beforeEnter: requireAuth,
    component: AnalyticsVue
  },
  {
    path: '/objects',
    name: 'objects',
    component: ObjectsVue
  },
  {
    path: '/modeling',
    name: 'modeling',
    beforeEnter: requireAuth,
    component: ModelingVue
  },
  {
    path: '/integration',
    name: 'integration',
    beforeEnter: requireAuth,
    component: IntegrationVue
  },
  {
    path: '/settings',
    name: 'settings',
    beforeEnter: requireAuth,
    component: SettingsVue
  },
  //Экран скрыт по задаче https://app.clickup.com/t/2n42p3k
  //"Технологии" сейчас не нужны ни в одном их бизнес-процессов
  /*
  {
    path: '/technologies',
    name: 'technologies',
    beforeEnter: requireAuth,
    component: TechnologiesVue
  },
  */
  {
    path: '/control',
    name: 'control',
    component: ControlVue,
    beforeEnter: (to, from, next) => {
      checkRoutePermissions(next, 'canReadControl')
    }
  },
  {
    path: '/excel-layers',
    component: ExcelLayersVue,
    beforeEnter: (to, from, next) => {
      if (!store.getters.token) {
        next('/login')
      }

      store.dispatch('loadUserData').then(() => {
        if (store.getters.permissions.canReadAggregateInfoLayer) {
          next()
        } else {
          next('/objects')
        }
      })
    },
    children: [
      {
        path: ':layerId',
        component: ExcelLayerVue,
        children: [
          {
            path: 'settings',
            name: 'excel-layer-settings',
            component: ExcelLayerSettingsVue,
            beforeEnter: (to, from, next) => {
              store.dispatch('loadUserData').then(() => {
                if (store.getters.permissions.canEditAggregateInfoLayer) {
                  next()
                } else {
                  next(`/excel-layers/${to.params.layerId}`)
                }
              })
            }
          },
          {
            path: '',
            name: 'excel-object-list',
            component: ExcelObjectListVue
          },
          {
            path: 'history',
            name: 'excel-layer-history',
            component: ExcelLayerHistory
          },
          {
            path: 'create-log',
            name: 'excel-layer-create-log',
            component: ExcelLayerCreateLog
          }
        ]
      },
      {
        path: '',
        name: 'excel-layer-list',
        component: ExcelLayerListVue
      }
    ]
  },
  {
    path: '/',
    redirect: (to) => {
      return { path: '/objects' }
    }
  }
]

if (env.VUE_APP_SHOW_B3_GIS) {
  routes.push({
    path: '/b3-gis',
    name: 'b3-gis',
    component: B3GisView
  })
}

export default function createRouter(store) {
  mainStore = store

  let router = new Router({
    mode: 'history',
    fallback: false,
    caseSensitive: false,
    scrollBehavior: () => ({
      y: 0
    }),
    routes
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js